import gql from 'graphql-tag';
import { USER_FRAGMENT } from './fragments';

export const registerMutation = gql`
  mutation RegisterMutation($input: RegisterInput!) {
    register(input: $input) {
      token
      errors {
        message
      }
    }
  }
`;

const currentUserQuery = gql`
  query CurrentUserQuery {
    me {
      ...UsersFields
    }
  }
  ${USER_FRAGMENT}
`;

const loginMutation = gql`
  mutation LoginMutation($email: String!, $password: String!) {
    login(input: { email: $email, password: $password }) {
      token
      errors {
        path
        message
      }
    }
  }
`;

export const editUserMutation = gql`
  mutation EditUserMutation($input: EditUserInput!) {
    editUser(input: $input) {
      user {
        ...UsersFields
      }
      errors {
        path
        message
      }
    }
  }
  ${USER_FRAGMENT}
`;

export const changePasswordMutation = gql`
  mutation ChangePasswordMutation($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      errors {
        path
        message
      }
    }
  }
`;

export const setAvatarMutation = gql`
  mutation SetAvatarMutation($input: SetAvatarInput!) {
    setAvatar(input: $input) {
      user {
        id
        email
        displayName
        avatarUrl
      }
      errors {
        path
        message
      }
    }
  }
`;

export { currentUserQuery, loginMutation };
